import { render, staticRenderFns } from "./info1.vue?vue&type=template&id=f85e18da&"
import script from "./info1.vue?vue&type=script&lang=js&"
export * from "./info1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../blsguanfang_blszf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports